import Group from 'components/utils/Group'
import type { TripItineraryData } from 'tripPlanner/api/types'
import DrawerHotelTileSkeleton from '../HotelListingDrawer/DrawerHotelTileSkeleton'
import type { DrawerExperienceSearchTile } from './ExperienceDetailView'
import ExperienceListingEmptyState from './ExperienceListingEmptyState'
import ExperienceSearchTile from './ExperienceSearchTile'

const DEFAULT_SKELETON_COUNT = 3

interface Props {
  experiences: Array<DrawerExperienceSearchTile>
  isLoading: boolean
  onSelectExperience: (experience: DrawerExperienceSearchTile) => void
  placeName: string
  browseAllResultsUrl: string
  itineraryData?: TripItineraryData
  onSendMessage?: (message: string) => void
  onAfterAction?: () => void
  /** Optional per-tile tracking offer lookup — enables Snowplow impression/click events */
  getTrackingOffer?: (offerId: string) => App.ExperienceOffer | undefined
  skeletonCount?: number
}

function ExperienceSearchResults({
  experiences,
  isLoading,
  onSelectExperience,
  placeName,
  browseAllResultsUrl,
  itineraryData,
  onSendMessage,
  onAfterAction,
  getTrackingOffer,
  skeletonCount = DEFAULT_SKELETON_COUNT,
}: Props) {
  if (isLoading) {
    return (
      <Group direction="vertical" gap={16}>
        {Array.from({ length: skeletonCount }, (_, index) => (
          <DrawerHotelTileSkeleton key={index} />
        ))}
      </Group>
    )
  }

  if (experiences.length === 0) {
    return (
      <ExperienceListingEmptyState
        placeName={placeName}
        searchUrl={browseAllResultsUrl}
      />
    )
  }

  return (
    <Group direction="vertical" gap={16}>
      {experiences.map((experience, index) => (
        <ExperienceSearchTile
          key={experience.offerId}
          experience={experience}
          onSelectExperience={onSelectExperience}
          position={index}
          trackingOffer={getTrackingOffer?.(experience.offerId)}
          itineraryData={itineraryData}
          onSendMessage={onSendMessage}
          onAfterAction={onAfterAction}
        />
      ))}
    </Group>
  )
}

export default ExperienceSearchResults
